import {Pipe, PipeTransform} from "@angular/core";
import {StrengMal} from "../tjenester/ressurser/generertNg2HttpKlient";
import {erNil} from "../støttefunksjoner/nilsjekk";
import {StrengMaler} from "felles/tjenester/StrengMaler";
import {kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";


/**
 * Pipe for interpolering av StrengMal instanser.
 * <pre>
 * Se {@link StrengMaler}
 *
 * Bruker:
 * Siden filteret returnerer html må [innerHTML] benyttes for at ikke htmlen skal escapes, eks:
 * <span [innerHTML]="kommentar.forelder.beskrivelse | strengMal"></span> eller
 * <span [innerHTML]="kommentar.forelder.beskrivelse | strengMal:'lang'"></span>
 *
 * format-argumentet kan være en av "lang", "kort" og angir hvorvidt
 * ft.StrenMal.somFullStreng eller ft.StrenMal.somKortStreng benyttes.
 *
 * Dersom format ikke er angitt benyttes "kort".
 * </pre>
 */
@Pipe({name: 'strengMal', pure: true, standalone: true})
export class StrengMalPipe implements PipeTransform {
    constructor(private strengMaler: StrengMaler) {
    }

    transform(mal: StrengMal | null, format: 'lang' | 'kort' = 'kort'): string | null {
        if (erNil(mal)) return '';
        //i påvente av en ng2-spesifikk impl av StrengMaler må vi passe på at datoer blir konvertert tilbake til Date
        const kopi:StrengMal = {malnavn: mal.malnavn, noeklerOgVerdier: kopierFraNg2TilAjs({...mal.noeklerOgVerdier})};
        return format == 'lang' ?
          this.strengMaler.somFullStreng(kopi) : this.strengMaler.somKortStreng(kopi);
    }
}
